import { ChangeDetectionStrategy, Component, OnInit, Signal } from '@angular/core';
import { CrmLayoutV2FragmentDirective } from '@touch4it/ng-swp/layout-v2';
import { CrmSelectComponent } from '@touch4it/ng-swp/form/inputs';
import { Observable } from 'rxjs';
import { CrmOption } from '@touch4it/ng-swp/common';
import { FormsModule } from '@angular/forms';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { CrmTranslatePipe } from '@touch4it/ng-swp/translate';
import { NzIconDirective } from 'ng-zorro-antd/icon';

import { WorkspacesSelectorProvider } from './workspaces-selector.provider';

@Component({
  selector: 'app-workspaces-selector',
  templateUrl: './workspaces-selector.component.html',
  styleUrls: ['./workspaces-selector.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [WorkspacesSelectorProvider],
  imports: [CrmSelectComponent, FormsModule, NzButtonComponent, CrmTranslatePipe, NzIconDirective],
})
export class WorkspacesSelectorComponent
  extends CrmLayoutV2FragmentDirective<WorkspacesSelectorProvider>
  implements OnInit
{
  protected workspace!: Signal<string | undefined>;
  protected addAllowed!: Signal<boolean>;
  protected collapsed!: Signal<boolean>;
  protected workspaces$!: Observable<CrmOption[]>;

  ngOnInit() {
    this.initProvider(WorkspacesSelectorProvider);
  }

  protected override initComponent(provider: WorkspacesSelectorProvider) {
    this.workspace = provider.workspace;
    this.addAllowed = provider.addAllowed;
    this.collapsed = provider.collapsed;
    this.workspaces$ = provider.getWorkspaces$();
  }

  protected setWorkspace(workspace: string) {
    this.provider.setWorkspace(workspace);
  }

  protected addWorkspace() {
    this.provider.workspaceAction('new');
  }

  protected editWorkspace() {
    this.provider.workspaceAction('profile');
  }
}
